import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const location = useLocation();

  useLayoutEffect(() => {
    // Make scroll behavior deterministic across SPA navigations.
    if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    if (location.hash) {
      const scrollToHashTarget = () => {
        const target = document.getElementById(location.hash.slice(1));
        target?.scrollIntoView({ behavior: 'auto', block: 'start' });
      };

      scrollToHashTarget();
      requestAnimationFrame(scrollToHashTarget);
      setTimeout(scrollToHashTarget, 50);
      return;
    }

    const scrollAllToTop = () => {
      // Lovable/Vite template often uses a fixed body + scrollable #root
      const root = document.getElementById('root');
      if (root) {
        root.scrollTop = 0;
        if ('scrollTo' in root) {
          root.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        }
      }

      // Window scroll
      window.scrollTo(0, 0);

      // Some browsers use these depending on mode
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      // If the app is using an internal scroll container (e.g., MasterLayout)
      const scrollContainers = document.querySelectorAll<HTMLElement>('#root, main.overflow-y-auto, [data-scroll-container]');
      scrollContainers.forEach((el) => {
        el.scrollTop = 0;
      });
    };

    // Do it immediately + after layout settles (images/fonts can shift content).
    scrollAllToTop();
    requestAnimationFrame(scrollAllToTop);
    setTimeout(scrollAllToTop, 50);
  }, [location.pathname, location.search, location.hash]);

  return null;
};
